/**
 * @file 图谱公用方法
 * @create yuqian
 * @update
 */

// 处理节点文字换行
const InsertEnter = function (name) {
    let width = 18
    name = name.replace(/[^\u4e00-\u9fa5]/gi, '')
    // 文字宽度
    let nameLen = name.length * 14
    // 每行字数,超过换行
    let num = 4
    // 文字宽度大于rect宽度时,计算每行最大字数
    if (nameLen > width) {
        num = Math.floor(width / 14)
    } else {
        num = Math.floor(nameLen / 14)
    }
    if (!num) num = 1
    var s = name,
        reg = new RegExp(`.{1,${num}}`, 'g'),
        rs = s.match(reg)
    if (rs.length < 4) {
        return [rs, rs.length]
    } else if (rs.length === 4) {
        return [[rs[2] + rs[0], rs[3] + rs[1]], rs.length]
    } else if (rs.length === 5) {
        return [[rs[3] + rs[0], rs[4] + rs[1], '' + rs[2]], 5]
    } else if (rs.length >= 6) {
        return [[rs[3] + rs[0], rs[4] + rs[1], '' + rs[2]], 6]
    }
    // else {
    //     return [[rs[4] + rs[0], rs[5] + rs[1], rs[6] + rs[2], rs[7] + rs[3]], 7]
    // }
}

// 求元素移动到目标位置所需要的 transform 属性值
const GetTransform = function (source, target, _dis) {
    let r
    if (target.x > source.x) {
        if (target.y > source.y) {
            r = Math.asin((target.y - source.y) / _dis)
        } else {
            r = Math.asin((source.y - target.y) / _dis)
            r = -r
        }
    } else {
        if (target.y > source.y) {
            r = Math.asin((target.y - source.y) / _dis)
            r = Math.PI - r
        } else {
            r = Math.asin((source.y - target.y) / _dis)
            r -= Math.PI
        }
    }
    r = r * (180 / Math.PI)
    return 'translate(' + source.x + ',' + source.y + ')rotate(' + r + ')'
}

// 求两点间的距离
const GetDis = function (s, t) {
    return Math.sqrt((s.x - t.x) * (s.x - t.x) + (s.y - t.y) * (s.y - t.y))
}

// 处理节点详情小弹框出现的位置
const GetNodePosition = function (event, a, b, NW) {
    let PW = event.offsetX + b.pWidth + NW
    let PH = event.offsetY + b.pHeight + NW
    // 判断弹框显示位置
    if (PW + NW >= a.width) {
        // 弹框在节点左侧
        if (PH >= a.height) {
            // 弹框在节点上侧
            return {
                right: `${a.width - event.offsetX + NW / 2}px`,
                bottom: `${a.height - event.offsetY + NW / 2}px`,
            }
        } else {
            // 弹框在节点下侧
            return {
                right: `${a.width - event.offsetX + NW / 2}px`,
                top: `${event.offsetY + NW / 2}px`,
            }
        }
    } else {
        // 弹框在节点右侧
        if (PH >= a.height) {
            // 弹框在节点上侧
            return {
                left: `${event.offsetX + NW / 2}px`,
                bottom: `${a.height - event.offsetY}px`,
            }
        } else {
            // 弹框在节点下侧
            return {
                left: `${event.offsetX + NW / 2}px`,
                top: `${event.offsetY + NW / 2}px`,
            }
        }
    }
}

// 处理文字删除HTML格式过滤器
const filterReplaceHTML = function (str) {
    if (str) {
        return str.replace(/<[^>]+>/g, '')
    }
}

// 处理文字特殊字符过滤器
const filterReplaceSpecial = function (str) {
    if (str) {
        let data = ''
        data = str.replace(/<\/?[^>]*>/g, '')
        data = data.replace(/&ldquo;/gi, '“')
        data = data.replace(/&rdquo;/gi, '”')
        data = data.replace(/&nbsp;/gi, ' ')
        data = data.replace(/&middot;/gi, '·')
        data = data.replace(/&deg;/gi, '°')
        data = data.replace(/&aacute;/gi, 'á')
        data = data.replace(/&igrave;/gi, 'ì')
        data = data.replace(/&ugrave;/gi, 'ù')
        data = data.replace(/&eacute;/gi, 'é')
        data = data.split('。')
        data = data[0] + '。'
        return data
    }
}

export default {
    InsertEnter,
    GetTransform,
    GetDis,
    GetNodePosition,
    filterReplaceHTML,
    filterReplaceSpecial,
}
